import { Input } from "../Input/Input";
import { Dropdown } from "../Dropdown/Dropdown";
import { Checkbox } from "../Checkbox/Checkbox";
import { Button } from "../buttons/Button/Button";
import { senderCategory } from "./assets";
import "./form.css";

export const Form = () => {
  return (
    <div className="form">
      <div className="inputs-line">
        <label>
          <span className="body3">YOUR NAME*</span>
          <Input placeholder="Your name" name="name" />
        </label>
        <label>
          <span className="body3">E-MAIL*</span>
          <Input placeholder="Your E-mail" name="mail" />
        </label>
      </div>
      <div className="inputs-line">
        <label>
          <span className="body3">PHONE</span>
          <Input placeholder="Your phone number" name="phone" />
        </label>
        <label>
          <span className="body3">ORGANIZATION</span>
          <Input placeholder="Organization" name="organization" />
        </label>
      </div>
      <div className="form-dropdown">
        <label>
          <span className="body3">Select a sender category*</span>
          <Dropdown options={senderCategory} />
        </label>
      </div>
      <label>
        <span className="body3">YOUR MESSAGE*</span>
        <textarea
          className="textarea"
          placeholder="Please enter your message"
        ></textarea>
      </label>
      <div className="submit-wrapper">
        <div className="checkbox-wrapper">
          <Checkbox />
          <p className="body4">
            <span>I agree to the</span> Terms of Use <span>and</span> Privacy
            Policy
          </p>
        </div>
        <div className="submit-button">
          <Button type="default">SUBMIT</Button>
        </div>
      </div>
    </div>
  );
};
